<template>
<div>
    <offer-list
        :event-type="eventType"
    />
</div>
</template>
    
<script>
import { ref, onUnmounted } from "@vue/composition-api";
import OfferList from '../components/event-list/EventList.vue'

export default {
    components: {
        OfferList
    },
    setup() {
        const eventType = ref('offers')

        return {
            eventType,
        }
    }
}
</script>